{
	"title": "Trebuie să vă autentificați",
	"description": "Pentru a vizualiza această pagină, este necesar să fiți autentificat(ă). Vă rugăm să vă autentificați. După aceea, veți fi redirecționat(ă) către pagina solicitată.",
	"primaryButtonTitle": "Deschide pagina de autentificare"
}
